(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dph-product-tabs"] && !Shopify.designMode) return;
  try {
    
  function initDphProductTabs(section) {
    /* ── Tabs ── */
    const tabs          = section.querySelectorAll('.dph-tabs__tab');
    const mobileToggles = section.querySelectorAll('.dph-tabs__mobile-toggle');
    const panels        = section.querySelectorAll('.dph-tabs__panel');

    function setActivePanel(target) {
      tabs.forEach(function (tab) {
        const isActive = tab.dataset.tab === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      mobileToggles.forEach(function (toggle) {
        const isActive = toggle.dataset.mobileToggle === target;
        toggle.classList.toggle('is-active', isActive);
        toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.panel === target);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActivePanel(tab.dataset.tab);
      });
    });

    mobileToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setActivePanel(toggle.dataset.mobileToggle);
      });
    });

    /* ── Ingredient Carousel ── */
    const carousel = section.querySelector('[data-carousel]');
    if (!carousel) return;

    const track    = carousel.querySelector('[data-carousel-track]');
    const btnPrev  = carousel.querySelector('[data-carousel-prev]');
    const btnNext  = carousel.querySelector('[data-carousel-next]');
    const cards    = track ? Array.from(track.children) : [];

    if (!track || cards.length === 0) return;

    let currentIndex = 0;

    function getVisibleCount() {
      return window.innerWidth <= 749 ? 1 : 3;
    }

    function updateCarousel() {
      if (window.innerWidth <= 749) {
        track.style.transform = '';
        if (btnPrev) btnPrev.disabled = true;
        if (btnNext) btnNext.disabled = true;
        return;
      }

      const visibleCount = getVisibleCount();
      const maxIndex     = Math.max(0, cards.length - visibleCount);
      currentIndex       = Math.min(currentIndex, maxIndex);

      if (btnPrev) btnPrev.disabled = currentIndex === 0;
      if (btnNext) btnNext.disabled = currentIndex >= maxIndex;

      if (maxIndex === 0) {
        track.style.transform = '';
        return;
      }

      const cardWidth    = track.offsetWidth / visibleCount;
      track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
      track.style.transition = 'transform 0.35s ease';
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        currentIndex = Math.max(0, currentIndex - 1);
        updateCarousel();
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        const visibleCount = getVisibleCount();
        const maxIndex     = Math.max(0, cards.length - visibleCount);
        currentIndex       = Math.min(maxIndex, currentIndex + 1);
        updateCarousel();
      });
    }

    window.addEventListener('resize', updateCarousel);
    updateCarousel();
  }

  /* Initiale Ausführung beim Seitenlade */
  document.querySelectorAll('[data-testid="dph-product-tabs"]').forEach(initDphProductTabs);

  /* Re-Initialisierung nach Theme-Editor Re-Render */
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-testid="dph-product-tabs"]');
    if (section) initDphProductTabs(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
